import React, { memo, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { ReactComponent as HideEyeIcon } from "../../assets/icons/eye-hide.svg";
import { ReactComponent as OpenEyeIcon } from "../../assets/icons/eye-open.svg";
import { ReactComponent as CopyIcon } from "../../assets/icons/copy.svg";
import useCopyToClipboard from "../../hooks/useCopyToClipboard";
import BaseIcon from "../BaseIcon";
import { useTranslation } from "react-i18next";
import "./style.scss";

function BaseInput({
  type,
  placeholder,
  id,
  name,
  value,
  label,
  onChange,
  disabled,
  autofocus,
  autocomplete,
  refInput,
  errorMessage,
  maxlength,
  required,
  wrapperStyle,
  className,
  max,
  min,
  isDatePickerOpen,
  openPicker,
  inputMode,
  copyOnClick,
  onBlur,
  disabledBlur,
}) {
  BaseInput.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    wrapperStyle: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    copyOnClick: PropTypes.func,
    openPicker: PropTypes.func,
    disabled: PropTypes.bool,
    disabledBlur: PropTypes.bool,
    autofocus: PropTypes.string,
    autocomplete: PropTypes.string,
    errorMessage: PropTypes.string,
    inputMode: PropTypes.string,
    maxlength: PropTypes.number,
    id: PropTypes.string,
    required: PropTypes.bool,
    isDatePickerOpen: PropTypes.bool,
    max: PropTypes.string,
    min: PropTypes.string,
    endAdornment: PropTypes.node,
    refInput: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(HTMLInputElement) }),
    ]),
  };
  const { isCopied } = useCopyToClipboard(".active-copy", id);
  const refLocal = useRef(null);
  const [isEyeOpen, setIsEyeOpen] = useState(false);
  const [isFloatLabel, setFloatLabel] = useState(false);
  const isError = (errorMessage && errorMessage.trim() !== "") || false;
  const toggleEye = () => setIsEyeOpen(!isEyeOpen);
  const { t } = useTranslation();
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const onChangeHandler = (event) => {
    if (type === "datepicker" && event.target.value.length > 10) {
      // console.log(event.target.value.slice(0, event.target.value.length - 1));
      event.target.value = event.target.value.slice(
        0,
        event.target.value.length + 1
      );
    }
    event.target?.value.length ? setFloatLabel(true) : setFloatLabel(false);
    onChange && onChange(event);
  };

  const onBlurHandler = (event) => {
    if (type === "datepicker" && event.target.value.length > 10) {
      // console.log(event.target.value.slice(0, event.target.value.length - 1));
      event.target.value = event.target.value.slice(
        0,
        event.target.value.length + 1
      );
    }
    event.target?.value.length ? setFloatLabel(true) : setFloatLabel(false);
    onBlur && onBlur(event);
  };

  useEffect(() => {
    if (type === "datepicker") {
      if (
        document.querySelector("#register-birthday")?.value.length ||
        document.querySelector("#update-age")?.value.length
      ) {
        setFloatLabel(true);
      } else {
        setFloatLabel(false);
      }
    }
  }, [isDatePickerOpen]);

  useEffect(() => {
    if (value?.length) {
      setFloatLabel(true);
      return;
    }
    setFloatLabel(false);
  }, [value]);

  const cls = ["base-input__input"];
  const clsInputWrapper = ["base-input"];
  if (isError) cls.push("base-input__hint_error", "error-input");
  if (wrapperStyle) clsInputWrapper.push(wrapperStyle);
  if (className) cls.push(className);
  if (type === "copy") cls.push("long-link-overflow");
  return (
    <div className={clsInputWrapper.join(" ")}>
      <div className={`base-input__label ${isFloatLabel ? "float-label" : ""}`}>
        {label}
      </div>
      {type === "password" && (
        <div onClick={toggleEye} className="base-input__eye">
          {isEyeOpen ? (
            <OpenEyeIcon className="base-input__eye_open eye-icon" />
          ) : (
            <HideEyeIcon className="base-input__eye_hide eye-icon" />
          )}
        </div>
      )}
      {type === "datepicker" && (
        <div onClick={openPicker} className="base-input__calendar">
          <BaseIcon className="base-input__calendar__icon" name="calendar" />
        </div>
      )}
      {type === "copy" && (
        <div
          onClick={copyOnClick}
          data-clipboard-target={`#${id}`}
          className="base-input__copy active-copy"
        >
          {isCopied ? (
            <div className="base-input__copy-label">
              <div className="base-input__copy-label_checked" />
            </div>
          ) : (
            <CopyIcon className="base-input__copy__icon" />
          )}
        </div>
      )}
      <input
        id={id}
        inputMode={inputMode}
        type={isEyeOpen ? "text" : type || "text"}
        className={cls.join(" ")}
        name={name}
        value={value ? value : ""}
        required={required}
        placeholder={placeholder}
        onChange={onChangeHandler}
        onBlur={!disabledBlur ? onBlurHandler : null}
        disabled={disabled}
        autoFocus={autofocus}
        maxLength={maxlength}
        max={max}
        min={min}
        autoComplete={autocomplete}
        ref={refInput || refLocal}
        onClick={isIOS ? openPicker : null}
      />
      {/*{isError && (*/}
      <div
        className={`base-input__hint ${isError && "base-input__hint_error"}`}
      >
        {errorMessage || ""}
      </div>
      {/*)}*/}
    </div>
  );
}

export default memo(BaseInput);
